import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import Swal from "sweetalert2";
import { Link, useParams } from "react-router-dom";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const Vehicle_details1 = () => {
  useAuthRedirect();
  const [data, setData] = useState([]);
  const [subAssemblies, setSubAssemblies] = useState([]);
  const [descriptions, setDescriptions] = useState([]);
  const [selectedSubAssembly, setSelectedSubAssembly] = useState("");
  const [selectedDescription, setSelectedDescription] = useState("");
  const [selectedBranch, setSelectedBranch] = useState(localStorage.getItem("branch") || "");
  const [userName, setUsername] = useState(localStorage.getItem("username") || "");
  const [partDetails, setPartDetails] = useState({
    fld_PartNumber : "",
    fld_Specification : "",
    fld_Qty : "",
    fld_UsageLimit : "",
  });
  const [hourMeter, setHourMeter] = useState("");
  const { vcode, branch, basis } = useParams();
const [loading, setLoading] = useState(false);

      const canEntry = hasPermission("Periodic Entry (Own Vehicle)", "entry");
      const canEdit  = hasPermission("Periodic Entry (Own Vehicle)", "edit");
      
  

  useEffect(() => {
  const fetchAllVehicleInfo = async () => {
    let progress = 0;

    const updateProgress = (value) => {
      const bar = document.getElementById("progress-bar");
      const text = document.getElementById("progress-text");
      if (bar) bar.style.width = `${value}%`;
      if (text) text.innerText = `Loading... ${value}%`;
    };

    Swal.fire({
      title: "Fetching Vehicle Details",
      html: `
        <div id="progress-container" style="width: 100%; background: #e0e0e0; border-radius: 5px;">
          <div id="progress-bar" style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); border-radius: 5px;"></div>
        </div>
        <p id="progress-text" style="margin-top: 10px; font-size: 14px;">Loading... 0%</p>
      `,
      showConfirmButton: false,
      allowOutsideClick: false,
      didOpen: () => updateProgress(0),
    });

    try {
      // 1. Fetch Sub Assemblies
      if (selectedBranch && vcode) {
        const subRes = await axios.get(`https://rfs2.infraconsoft.net.in/api/vehicle_main_list_subassembly?vehicle_code=${vcode}&branch_code=${selectedBranch}`);
        setSubAssemblies(subRes.data.subassemblies || []);
        progress = 33; updateProgress(progress);
      }

      // 2. Fetch Descriptions for Selected SubAssembly
      if (selectedSubAssembly) {
        const descRes = await axios.get(`https://rfs2.infraconsoft.net.in/api/get_descriptions?subid=${selectedSubAssembly}`);
        setDescriptions(descRes.data || []);
        progress = 66; updateProgress(progress);
      } else {
        setDescriptions([]);
        setPartDetails({ fld_PartNumber: "", fld_Specification: "", fld_Qty: "", fld_UsageLimit: "" });
      }

      // 3. Fetch Part Details for Selected Description
      if (selectedDescription) {
        const partRes = await axios.get(`https://rfs2.infraconsoft.net.in/api/get_description_details?empdata=${selectedDescription}`);
        setPartDetails(partRes.data || {});
        progress = 100; updateProgress(progress);
      } else if (!selectedSubAssembly) {
        // Reset part details if no sub-assembly selected
        setPartDetails({ fld_PartNumber: "", fld_Specification: "", fld_Qty: "", fld_UsageLimit: "" });
        progress = 100; updateProgress(progress);
      }

      setTimeout(() => Swal.close(), 400);
    } catch (error) {
      console.error("Error loading vehicle-related data:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to load vehicle data. Check network or try again.",
      });
    }
  };

  // Only run if any valid trigger is active
  if (selectedBranch && vcode) {
    {canEntry && (
    fetchAllVehicleInfo()
    )}
  }
}, [selectedBranch, vcode, selectedSubAssembly, selectedDescription]);

  useEffect(() => {
  if (selectedBranch && vcode) {
    setLoading(true); // Start loading
    axios
      .get(`https://rfs2.infraconsoft.net.in/api/details1_data?vehicle_code=${vcode}&branch_code=${selectedBranch}`)
      .then((response) => {
        setData(response.data.vehicles);
        setLoading(false); // End loading
      })
      .catch((error) => {
        console.error("Error fetching vehicles:", error);
        setLoading(false); // End loading even on error
      });
  }
}, [selectedBranch, vcode]);


  const handleSubmit = async (e) => {
    e.preventDefault();

     if (!selectedSubAssembly.trim()) {
      Swal.fire({
        icon: 'warning',
        title: 'Empty Field',
        text: 'Please Select Your SubAssembly!',
      });
      return;
    }

     if (!selectedDescription.trim()) {
      Swal.fire({
        icon: 'warning',
        title: 'Empty Field',
        text: 'Please Select Your Description!',
      });
      return;
    }

if (!hourMeter || hourMeter.trim() === "") {
  Swal.fire({
    icon: 'warning',
    title: 'Empty Field',
    text: 'Please Enter Hour Meter!',
  });
  return;
}

const hourMeterNum = Number(hourMeter);

if (isNaN(hourMeterNum)) {
  Swal.fire({
    icon: 'warning',
    title: 'Invalid Input',
    text: 'Hour Meter must be a number.',
  });
  return;
}

if (hourMeterNum <= 0) {
  Swal.fire({
    icon: 'warning',
    title: 'Invalid Value',
    text: 'Hour Meter must be greater than zero.',
  });
  return;
}


  

    const data = {
        vehicleCode: vcode,
        user: userName,
        branch: selectedBranch,
        sub_assembly: selectedSubAssembly,
        description: selectedDescription,
        partNo: partDetails?.fld_PartNumber || null,
        spec: partDetails?.fld_Specification || null,
        qty: partDetails?.fld_Qty || null,
        usageLimit: partDetails?.fld_UsageLimit || null,
        hourMeter,
    };

    // console.log("Submitting Data:", data); 

    try {

       Swal.fire({
          title: "Submitting...",
          text: "Please wait while we process your request.",
          allowOutsideClick: false,
          didOpen: () => {
              Swal.showLoading();
          },
      });
        const response = await axios.post("https://rfs2.infraconsoft.net.in/api/insert", data);
        
        // console.log("Server Response:", response.data);
        
        if (response.status === 200) {
            Swal.fire({
                title: "Success!",
                text: "Data saved successfully.",
                icon: "success",
                confirmButtonText: "OK",
            });
        } else {
            console.error("Unexpected response status:", response.status);
            Swal.fire({
                title: "Unexpected Error",
                text: "Something went wrong!",
                icon: "error",
                confirmButtonText: "OK",
            });
        }
        window.location.reload();
        
    } catch (error) {
        console.error("Insertion Error:", error);

        if (error.response) {
            console.error("Server Response Data:", error.response.data);
            console.error("Status Code:", error.response.status);
            
            if (error.response.status === 400) {
                // 409 Conflict - Record already exists
                Swal.fire({
                    title: "Duplicate Entry",
                    text: "Record already exists!",
                    icon: "warning",
                    confirmButtonText: "OK",
                });
            } else {
                Swal.fire({
                    title: "Error",
                    text: error.response.data.error || "Server error",
                    icon: "error",
                    confirmButtonText: "OK",
                });
            }
        } else if (error.request) {
            console.error("No response received from server");
            Swal.fire({
                title: "Server Error",
                text: "Server is not responding. Please try again later.",
                icon: "error",
                confirmButtonText: "OK",
            });
        } else {
            console.error("Request Error:", error.message);
            Swal.fire({
                title: "Unexpected Error",
                text: error.message,
                icon: "error",
                confirmButtonText: "OK",
            });
        }
    }
};
const handleChange = async (item) => {
  if (window.confirm("Are you sure you want to update?")) {
    try {
      Swal.fire({
          title: "Submitting...",
          text: "Please wait while we process your request.",
          allowOutsideClick: false,
          didOpen: () => {
              Swal.showLoading();
          },
      });
      const response = await axios.put("https://rfs2.infraconsoft.net.in/api/update_vehicle_maintenance", {
        vehicle_code: vcode,
        SlNo: item.SlNo,
        last_modified_hr: item.last_modified_hr,
        changing_hrs: item.changing_hrs,
        vehicle_basis: item.vehicle_basis,
        cumulative: item.cumulative,
        fld_wohrs: item.fld_wohrs,
        fld_wokm: item.fld_wokm,
      });

       Swal.fire({
                title: "Success!",
                text: "Last Hr/Km Changed successfully.",
                icon: "success",
                confirmButtonText: "OK",
            });
      window.location.reload();
      
      
      axios.get(`https://rfs2.infraconsoft.net.in/api/details1_data?vehicle_code=${vcode}&branch_code=${selectedBranch}`)
        .then((response) => {
          setData(response.data.vehicles);
        })
        .catch((error) => {
          console.error("Error fetching updated vehicles:", error);
        });

    } catch (error) {
      console.error("Error updating details:", error);
      alert("Failed to update record");
    }
  }
};


if (!canEntry) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
           <div className="back-div">
                              <h2 className="add-txt">Vehicle Maintenance - Details No 1</h2>
                              <Link to='/vehicle_maintenance_list'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                              </div>

          <div><Time /></div>
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Code :</label>
                <input type="text" value={vcode} readOnly />
              </div>
              <div className="form-group">
                <label>Branch Name :</label>
                <input type="text" value={selectedBranch} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Sub Assembly :</label>
                <select value={selectedSubAssembly} onChange={(e) => setSelectedSubAssembly(e.target.value)}>
                  <option value="">-select one-</option>
                  {subAssemblies.map((item) => (
                    <option key={item.fld_subid} value={item.fld_subid}>{item.fld_subassembly}</option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Description :</label>
                <select value={selectedDescription} onChange={(e) => setSelectedDescription(e.target.value)}>
                  <option value="">-select one-</option>
                  {descriptions.map((item) => (
                    <option key={item.fld_id} value={item.fld_id}>{item.fld_Descriptions}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Part Number/Oil Grade :</label>
                <input type="text" value={partDetails.fld_PartNumber} readOnly />
              </div>
              <div className="form-group">
                <label>Specification :</label>
                <input type="text" value={partDetails.fld_Specification} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Qty :</label>
                <input type="text" value={partDetails.fld_Qty} readOnly />
              </div>
              <div className="form-group">
                <label>Usage Limit :</label>
                <input type="text" value={partDetails.fld_UsageLimit} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Hour meter reading :</label>
                <input type="text" value={hourMeter} onChange={(e) => setHourMeter(e.target.value)} />
              </div>
              <div className="form-group">
                <label>Current Date :</label>
                <input
  type="text"
  value={new Date().toLocaleDateString("en-GB")} // d/m/y format
/>


              </div>
            </div>

            <div className="btn-cls">
            <button type="submit" className="submit-btn">Submit</button>
            </div>

          </form>
        </div>

        <div className="content-table">
          <table>
  <thead>
    <tr>
      <th style={{ width: "50px" }}>S.No</th>
      <th style={{ width: "150px" }}>Description</th>
      <th style={{ width: "100px" }}>Oil Grade</th>
      <th style={{ width: "130px" }}>Last Changed {basis}</th>
      <th style={{ width: "120px" }}>Service {basis}</th>
      <th style={{ width: "150px" }}>Next service cum {basis}</th>
      <th style={{ width: "150px" }}>Current Cum {basis}</th>
      <th style={{ width: "120px" }}>Remaining {basis}</th>
      <th style={{ width: "90px" }}>Change</th>
      <th style={{ width: "70px" }}>Alerts</th>
      {canEdit && (
      <th style={{ width: "70px" }}>Edit</th>
      )}
    </tr>
  </thead>
  <tbody>
    {loading ? (
      <tr>
        <td colSpan="11" className="text-center">Loading Please wait.....</td>
      </tr>
    ) : data.length > 0 ? (
      data.map((item, index) => {
        const service_km = parseInt(item.last_modified_hr || 0) + parseInt(item.changing_hrs || 0);
        const service_value =
          item.vehicle_basis === "Hour"
            ? parseInt(item.cumulative || 0) + parseInt(item.fld_wohrs || 0)
            : parseInt(item.cumulative || 0) + parseInt(item.fld_wokm || 0);
        const remaingHr = service_km - service_value;

        return (
          <tr key={index}>
            <td style={{ width: "50px" }}>{index + 1}</td>
            <td style={{ width: "150px" }}>{item.fld_Descriptions}</td>
            <td style={{ width: "100px" }}>{item.oilgrade}</td>
            <td style={{ width: "130px" }}>{item.last_modified_hr}</td>
            <td style={{ width: "120px" }}>{item.changing_hrs}</td>
            <td style={{ width: "150px" }}>{service_km}</td>
            <td style={{ width: "150px" }}>{service_value}</td>
            <td style={{ width: "120px" }}>{remaingHr}</td>
            <td style={{ width: "90px" }}>
              <button onClick={() => handleChange(item)}>Change</button>
            </td>
            <td style={{ width: "70px" }}>
              {remaingHr < 0 && (
                <p className="alert">
                  <i className="fa-solid fa-triangle-exclamation"></i>
                </p>
              )}
            </td>
            {canEdit && (
            <td style={{ width: "70px" }}>
              <Link
                to={`/vehicle_maintanence_details_edit/${item.SlNo}/${vcode}/${item.branch_Code}`}
                className="edit"
              >
                <i className="fa-solid fa-pen-to-square"></i>
              </Link>
            </td>
            )}
          </tr>
        );
      })
    ) : (
      <tr>
        <td colSpan="11">No Data Available</td>
      </tr>
    )}
  </tbody>
</table>

        </div>
      </div>
    </div>
  );
};

export default Vehicle_details1;